import { Component, Vue } from 'vue-property-decorator';
import ChatWindow from 'vue-advanced-chat';
import ChatModule from '@/store/modules/chat-module';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import { itiMessageService, itiSignalRService } from '@/iti-core-vue';
import { Room } from '@/shared/dtos/room';
import { Message } from '@/shared/dtos/message';
import ChatMultiSala from '@/components/chat_multi_sala/chat-multi-sala.vue';
import ChatUnaSala from '@/components/chat_una_sala/chat-una-sala.vue';
@Component({
    components: {
        ChatWindow,
        ChatMultiSala,
        ChatUnaSala
    },
})
export default class AdvancedChat extends Vue {
    public roomId: number = 1;
}
